// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-post-sidebar__panel .condition-natural-language {
    margin-top: 12px;
    font-family: monospace, monospace;
    background-color: #f0f0f1;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #e0e0e1;
}

.condition-pro-features-notice {
    font-style: italic;
    margin-top: 12px;
}

.ruleGroup {
    margin: none;
    background: none;
    border: none;
}

.block-editor-inspector-popover-header__heading {
    font-size: 13px !important;
    margin-bottom: 16px !important;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/conditionals.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC","sourcesContent":[".edit-post-sidebar__panel .condition-natural-language {\n    margin-top: 12px;\n    font-family: monospace, monospace;\n    background-color: #f0f0f1;\n    padding: 12px;\n    border-radius: 4px;\n    border: 1px solid #e0e0e1;\n}\n\n.condition-pro-features-notice {\n    font-style: italic;\n    margin-top: 12px;\n}\n\n.ruleGroup {\n    margin: none;\n    background: none;\n    border: none;\n}\n\n.block-editor-inspector-popover-header__heading {\n    font-size: 13px !important;\n    margin-bottom: 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
